import { InputMask } from "@react-input/mask";
import { useEffect, useState } from "react";
import BoxAlert from "../../../../components/boxAlert/index.jsx";
import TabMenu from "../../../../components/tabMenu/index.jsx";
import formatValues from "../../../../scripts/formatValues";
import axios from "../../../../services/axios-config";
import styles from "./css/userMenu.module.css";



export default function UserMenu(props) {

  // CONTROLA A ABERTURA DO MENU DE EDIÇÃO DOS DADOS DA EMPRESA
  const [user, setUser] = useState([]);

  // LOADING CONTROL
  const [loadingAlertButton, setLoadingAlertButton] = useState(false);

  // ALERTS CONTROL
  const [warnAlert, setWarnAlert] = useState({ show: false, title: null, text: null,});
  const [confirmPaymentAlert, setConfirmPaymentAlert] = useState(false);
  const [confirmPaymentDateAlert, setConfirmPaymentDateAlert] = useState(false);
  const [confirmPaymentDateValue, setConfirmPaymentDateValue] = useState(null);
  const [confirmPaymentTypeValue, setConfirmPaymentTypeValue] = useState('monthly');
  const [openExtendTrialAlert, setOpenExtendTrialAlert] = useState(false);
  const [extendTrialValue, setExtendTrialValue] = useState('');




  useEffect(() => setUser(props.data), [props])


  // FUNÇÃO QUE CONTROLA A CONFIRMAÇÃO DE PAGAMENTO DA MENSALIDADE DE UMA EMPRESA
  const handleConfirmPayment = async (user) => {
    try {
      setLoadingAlertButton(true);

      let nextPayment;
      
      if(confirmPaymentTypeValue == 'monthly'){
        nextPayment = `${new Date(user.payment_control.next_payment).getFullYear()}-${new Date().getMonth() + 1}-${new Date(user.payment_control.next_payment).getDay()}`;
        
      } else {
        nextPayment = `${new Date(user.payment_control.next_payment).getFullYear() + 1}-${new Date().getMonth()}-${new Date(user.payment_control.next_payment).getDay()}`;
      }

      const res = await axios.post(`/admin/cmv/users/payments/register`, {
        userId: user.id,
        nextPayment: nextPayment,
        expectedDay: user.payment_control.next_payment,
        confirmedDate: confirmPaymentDateValue
          ? new Date(confirmPaymentDateValue).toISOString()
          : new Date().toISOString(),
        paymentType: confirmPaymentTypeValue
      });

      if (res.status == 200) {
        setWarnAlert({
          show: true,
          title: "Alerta",
          text: "O pagamento da mensalidade do usuário selecionado foi registrado com sucesso!",
        });

        setConfirmPaymentDateAlert(false);

        let data = user;
        data.payment_control.next_payment = nextPayment;
        data.payment_control.overdue = false;

        setUser(user);
      }

    } catch (error) {
      console.error("ERROR - CONFIRM PAYMENT FUNCTION:", error);
      setWarnAlert({
        show: true,
        title: "Erro",
        text: "Não foi possível confirmar o pagamento no momento. Tente novamente em instantes ou entre em contato com a equipe de desenvolvimento para averiguar a situação!",
      });

    } finally {
      setLoadingAlertButton(false);
    }
  };
  
  
  const handleExtendTrial = async () => {
    try {
      setLoadingAlertButton(true);

      const [day, month, year] = extendTrialValue.split('/');

      const formattedDate = `${year}-${month}-${day}`;
      const finalDate = new Date(formattedDate).toISOString();

      const currentDate = new Date().getTime();
      const finalDateMilliseconds = new Date(formattedDate).getTime();

      if(finalDateMilliseconds <= currentDate){
        setWarnAlert({show: true, title: 'Alerta', text: 'Insira um valor de data final de teste maior que a data atual para extender o teste do usuário corretamente!'});
        return;
      }

      const res = await axios.post(`/admin/cmv/users/trial/extend`, {
        userId: user.id,
        finalDate: finalDate
      });

      if (res.status == 200) {
        setWarnAlert({
          show: true,
          title: "Alerta",
          text: "O teste do usuário foi estendido com sucesso!",
        });

        setOpenExtendTrialAlert(false);

        let data = user;
        data.payment_control.next_payment = finalDate;
        data.trial.end_date = finalDate;
        data.trial.status = true;
        data.payment_control.overdue = false;

        setUser(user);
      }
      
    } catch (error) {
      console.error("ERROR - CONFIRM PAYMENT FUNCTION:", error);
      setWarnAlert({
        show: true,
        title: "Erro",
        text: error?.response?.data?.error ?? "Não foi possível extender o teste do usuário no momento. Tente novamente em instantes ou entre em contato com a equipe de desenvolvimento para averiguar a situação!",
      });

    } finally {
      setLoadingAlertButton(false);
    }
  };






  // SCREEN =============================================>

  return props.view && (
    <TabMenu
      title="Usuário (CMV)"
      onClose={() => props.close()}
    >
      <>

        <div className={styles.informationsArea}>
          {/* <======================== DADOS DO USUÁRIO ========================> */}

          <div className={styles.titleArea}>
            <p className={styles.titleInformations}>Dados do usuário:</p>
          </div>
          <p className={styles.textInformations}>
            <b>Nome:</b> {user?.name}
          </p>
          <p className={styles.textInformations}>
            <b>Telefone:</b> {user?.phone}
          </p>
          <p className={styles.textInformations}>
            <b>CPF:</b> {user?.document ?? 'Sem dados'}
          </p>
          <p className={styles.textInformations}>
            <b>Email:</b> {user?.email}
          </p>

          <div className={styles.actionButtonsArea} style={{marginTop: 0}}>
            <button className={styles.actionButtonConfig} style={{ marginTop: 30, backgroundColor: 'green' }} onClick={() => window.open(`https://wa.me/${user?.phone.replace('(', '').replace(')', '').replace('-', '').replaceAll(' ', '')}`)}>
              <p className={styles.actionButtonText}>Entrar em contato</p>
            </button>
          </div>

          {/* <======================== DADOS DE TRIAL ========================> */}

          {user?.trial ? (
            <>
              <div className={styles.titleArea}>
                <p className={styles.titleInformations}>Trial da plataforma (CMV):</p>
              </div>

              <p className={styles.textInformations}>
                <b>Status:</b>{" "}
                {user?.trial.status ? 'Ativo' : "Expirado"}
              </p>

              <p className={styles.textInformations}>
                <b>Intervalo de teste:</b>{" "}
                {new Date(user?.created_at).toLocaleDateString() + ' - ' + new Date(user?.trial.end_date + "T00:00:00").toLocaleDateString() }
              </p>

              <div className={styles.actionButtonsArea} style={{marginTop: 0}}>
                <button className={styles.actionButtonConfig} style={{ marginTop: 30, backgroundColor: '#2eb4f1' }} onClick={() => setOpenExtendTrialAlert(true)}>
                  <p className={styles.actionButtonText}>Extender teste</p>
                </button>
              </div>


            </>
          
          ) : null}



          {/* <======================== DADOS DE PAGAMENTO ========================> */}

          <div className={styles.titleArea}>
            <p className={styles.titleInformations}>Dados de pagamento:</p>
          </div>
          
              <p className={styles.textInformations}>
                <b>Mensalidade:</b>{" "}
                {formatValues(
                  user?.payment_control.value || "00.00"
                )}
              </p>

              <p className={styles.textInformations}>
                <b>Próximo pagamento:</b>{" "}
                {user?.payment_control.next_payment
                  ? new Date(
                      user?.payment_control.next_payment
                    ).toLocaleDateString()
                  : "Não registrado"}
              </p>

              <p
                className={styles.textInformations}
                style={{ marginTop: 15 }}
              >
                <b>Inadimplente:</b>
                <span
                  style={{
                    marginLeft: 10,
                    padding: "3px 10px",
                    backgroundColor: user?.payment_control.overdue
                      ? "red"
                      : "green",
                    color: "#fff",
                    borderRadius: 10,
                  }}
                >
                  {user?.payment_control.overdue
                    ? "Sim"
                    : "Em dia"}
                </span>
              </p>

              <div className={styles.actionButtonsArea}>
                <button
                  className={styles.actionButtonConfig}
                  style={{ backgroundColor: "green" }}
                  onClick={() => setConfirmPaymentAlert(true)}
                >
                  <p className={styles.actionButtonText}>
                    Confirmar pagamento
                  </p>
                </button>
              </div>

          
        </div>

        {/* <=============== ALERTS CONTROL ===============> */}


        {/* CONFIRM PAYMENT ALERT */}

        <BoxAlert
          show={confirmPaymentAlert}
          title={"Confirmar pagamento"}
          text={`Tem certeza que você deseja confirmar um pagamento de mensalidade para o usuárioo "${props.data?.name}"?`}
          showButtons={true}
          cancelButtonText={"Cancelar"}
          confirmButtonText={"Prosseguir"}
          confirmFunction={() => {
            setConfirmPaymentDateAlert(true);
            setConfirmPaymentAlert(false);
          }}
          onClose={() => setConfirmPaymentAlert(false)}
        />

        <BoxAlert
          show={openExtendTrialAlert}
          title={"Extender teste"}
          showCloseButton
          body={
            <div style={{minHeight: 300}}>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', marginTop: 20}}>

                <p style={{textAlign: 'start', fontSize: 13}}>Insira uma data final para expandir a data de teste da plataforma para o usuário.</p>

                <p style={{marginTop: 15}}>Insira uma data:</p>

                <InputMask
                  className={styles.inputConfig}
                  style={{ width: '100%', marginTop: 10 }}
                  mask="__/__/____"
                  replacement={{ _: /\d/ }}
                  placeholder={new Date().toLocaleDateString()}
                  value={extendTrialValue}
                  onChange={({ target: { value } }) => setExtendTrialValue(value)}
                />

                <button style={{width: '100%', height: 35, marginTop: 25, marginLeft: 'auto', marginRight: 'auto', backgroundColor: '#2eb4f1', color: '#fff', borderWidth: 0.5, borderColor: '#a3a3a3', borderRadius: 5}} disabled={loadingAlertButton} onClick={() => handleExtendTrial()}>
                  {loadingAlertButton ? (
                    <p>Carregando...</p>

                  ) : (
                    <p>Confirmar</p>
                  )}
                </button>
              </div>
            </div>
          }
          onClose={() => {
            setOpenExtendTrialAlert(false);
          }}
        />


        <BoxAlert
          show={confirmPaymentDateAlert}
          title={"Confirmar pagamento"}
          showCloseButton
          body={
            <div style={{minHeight: 300}}>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', marginTop: 20}}>

                <p style={{textAlign: 'start', fontSize: 13}}>Para confirmar o pagamento da mensalidade, selecione o tipo da mensalidade e insira uma data ou simplesmente pressione "confirmar" para continuar com a data atual.</p>

                <p style={{marginTop: 15}}>Selecione o tipo:</p>

                <div style={{width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 10, marginTop: 10}}>
                  <button style={{width: '48%', paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderWidth: 1, borderColor: '#a3a3a3', borderRadius: 5, backgroundColor: confirmPaymentTypeValue == 'monthly' ? '#2eb4f1' : '#fff', color: confirmPaymentTypeValue == 'monthly' ? '#fff' : '#000'}} onClick={() => setConfirmPaymentTypeValue('monthly')}>
                    <p>Mensal</p>
                  </button>
                  <button style={{width: '48%', paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, borderWidth: 1, borderColor: '#a3a3a3', borderRadius: 5, backgroundColor: confirmPaymentTypeValue == 'annual' ? '#2eb4f1' : '#fff', color: confirmPaymentTypeValue == 'annual' ? '#fff' : '#000'}} onClick={() => setConfirmPaymentTypeValue('annual')}>
                    <p>Anual</p>
                  </button>
                </div>

                <p style={{marginTop: 15}}>Insira uma data:</p>

                <InputMask
                  className={styles.inputConfig}
                  style={{ width: '100%', marginTop: 10 }}
                  mask="__/__/____"
                  replacement={{ _: /\d/ }}
                  placeholder={new Date().toLocaleDateString()}
                  value={confirmPaymentDateValue}
                  onChange={({ target: { value } }) => setConfirmPaymentDateValue(value)}
                />

                <button style={{width: '100%', height: 35, marginTop: 25, marginLeft: 'auto', marginRight: 'auto', backgroundColor: '#2eb4f1', color: '#fff', borderWidth: 0.5, borderColor: '#a3a3a3', borderRadius: 5}} disabled={loadingAlertButton} onClick={() => handleConfirmPayment(user)}>
                  {loadingAlertButton ? (
                    <p>Carregando...</p>

                  ) : (
                    <p>Confirmar</p>
                  )}
                </button>
              </div>
            </div>
          }
          onClose={() => {
            setConfirmPaymentDateValue('');
            setConfirmPaymentTypeValue('monthly')
            setConfirmPaymentDateAlert(false);
          }}
        />


        {/* WARN ALERT */}

        <BoxAlert
          show={warnAlert.show}
          title={warnAlert.title}
          text={warnAlert.text}
          onClose={() => setWarnAlert({show: false, title: null, text: null})}
        />

      </>
    </TabMenu>
  );
}
